<template>
  <dd-customer-page :customer-id="activeCustomerId" header="Polissen">
    <template v-slot:tabs>
      <dd-tab-group v-model="activeCustomerId">
        <dd-tab v-for="(customer, idx) in familyArray" :key="idx">
          <CustomerTab :customer="customer"/>
        </dd-tab>
      </dd-tab-group>
    </template>
    <template v-slot:content>
      <dd-tab-content-wrapper>
        <dd-tab-content v-for="(customer, idx) of familyArray" :key="customer.id" :id="customer.id">
          <pane-component :customer="customer" :customer-id="customer.id"></pane-component>
        </dd-tab-content>
      </dd-tab-content-wrapper>
    </template>
    <template v-slot:buttons>
      <dd-rounded-button :href="createPolicy" type="success" icon="mdi mdi-file-plus" data-dusk="create-policy">
        Polis aanmaken
      </dd-rounded-button>
      <dd-rounded-button :href="createPackage" type="primary" icon="mdi mdi-package-variant" data-dusk="create-package">
        Pakket aanmaken
      </dd-rounded-button>
      <dd-rounded-button :href="insuranceMove" type="primary" icon="mdi mdi-file-move" data-dusk="move-policy">
        Polissen verhuizen
      </dd-rounded-button>
    </template>
  </dd-customer-page>
</template>

<script>
import store from './store';
import {mapFields} from 'vuex-map-fields';
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import PaneComponent from './components/PaneComponent.vue';
import AttachableCategoryTemplateTypeEnum from '../../../enums/AttachableCategoryTemplateTypeEnum';
import CustomerTab from "./components/CustomerTab.vue";

export default {
  name: "InsurancePage",
  components: {
    CustomerTab,
    PaneComponent,
  },
  beforeCreate() {
    const STORE_KEY = '$_policy_page'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  created() {
    this.setCategory({
      id: AttachableCategoryTemplateTypeEnum.INSURANCE,
      name: 'Polissen',
    });
    this.getDisplayState();
    this.setActiveCustomerId(this.$route.params.customer);

    this.getFamily(this.activeCustomerId);
  },
  methods: {
    ...mapMutations({
      setCategory: 'SET_CATEGORY',
    }),
    ...mapActions('$_policy_page', {
      getFamily: 'getFamily',
      getDisplayState: 'getDisplayState',
      setFamily: 'setFamily',
    }),
    ...mapMutations(`$_policy_page`, {
      setActiveCustomerId: 'SET_ACTIVE_CUSTOMER_ID',
      setPackageCount: 'SET_PACKAGE_COUNT',
      setPolicyCount: 'SET_POLICY_COUNT',
    })
  },
  computed: {
    ...mapFields('$_policy_page', {
      activeCustomerId: 'activeCustomerId',
    }),
      createPolicy() {
        return this.route('vue.insurance.policy.createSingle', {
          customer: this.activeCustomerId,
        })
      },
      createPackage() {
        return this.route('vue.insurance.package.create', {
          customer: this.activeCustomerId
        });
      },
      insuranceMove() {
        return this.route('insurance.move', { customer: this.activeCustomerId });
      },
    ...mapState(`$_policy_page`, {
      customerId: 'customerId',
      filterLoaded: 'filterLoaded',
    }),
    ...mapGetters('$_policy_page', {
      familyArray: 'familyArray',
      policyTableHeaders: 'policyTableHeaders',
    }),
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
